import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { NewbuildingCompareFlightModalContainer } from 'shared/containers/NewbuildingCompareFlightModal';
import { getJsonQuery } from 'shared/selectors/getJsonQuery';

import { trackCompareFlightBannerClick, trackCompareFlightBannerShow } from './tracking';
import { NewbuildingCompareFlightBanner } from '../../components/NewbuildingCompareFlightBanner';

export const NewbuildingCompareFlightBannerContainer: React.FC = () => {
  const jsonQuery = useSelector(getJsonQuery);
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const handleShow = React.useCallback(() => {
    trackCompareFlightBannerShow(jsonQuery);
  }, [jsonQuery]);

  const handleBannerClick = React.useCallback(() => {
    trackCompareFlightBannerClick(jsonQuery);
    setIsModalOpen(true);
  }, [jsonQuery]);

  const handleModalClose = React.useCallback(() => {
    setIsModalOpen(false);
  }, []);

  return (
    <>
      <ActionAfterViewObserver callback={handleShow} percentVisible={0.5} triggerOnce>
        <NewbuildingCompareFlightBanner onClick={handleBannerClick} />
      </ActionAfterViewObserver>

      {isModalOpen && <NewbuildingCompareFlightModalContainer onClose={handleModalClose} />}
    </>
  );
};
